module.exports = __webpack_public_path__ + "img/logo04_sem_slogan.1742579a.svg";